import STORE from "../context";
import getChargeData from "./chargedata";
import { md5 } from "../utils/encryption";
import { getValueAtPath, isBoolean, isFunction, withProperties } from "../utils";

let ALLOW_MIXPANEL;
let MIXPANEL_INITIALIZED;

let TX_REF;
let MERCHANT_NAME;
let CUSTOMER_EMAIL;
let CUSTOMER_FIRSTNAME;
let CUSTOMER_LASTNAME;

// const mixpanel = require("mixpanel-browser");

function __initMixpanel__() {
  if (MIXPANEL_INITIALIZED !== true) {
    (function (f, b) {
      if (!b.__SV) {
        var e, g, i, h; window.mixpanel = b; b._i = []; b.init = function (e, f, c) {
          function g(a, d) { var b = d.split("."); 2 == b.length && (a = a[b[0]], d = b[1]); a[d] = function () { a.push([d].concat(Array.prototype.slice.call(arguments, 0))) } } var a = b; "undefined" !== typeof c ? a = b[c] = [] : c = "mixpanel"; a.people = a.people || []; a.toString = function (a) { var d = "mixpanel"; "mixpanel" !== c && (d += "." + c); a || (d += " (stub)"); return d }; a.people.toString = function () { return a.toString(1) + ".people (stub)" }; i = "disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(" ");
          for (h = 0; h < i.length; h++)g(a, i[h]); var j = "set set_once union unset remove delete".split(" "); a.get_group = function () { function b(c) { d[c] = function () { call2_args = arguments; call2 = [c].concat(Array.prototype.slice.call(call2_args, 0)); a.push([e, call2]) } } for (var d = {}, e = ["get_group"].concat(Array.prototype.slice.call(arguments, 0)), c = 0; c < j.length; c++)b(j[c]); return d }; b._i.push([e, f, c])
        }; b.__SV = 1.2; e = f.createElement("script"); e.type = "text/javascript"; e.async = !0; e.src = "undefined" !== typeof MIXPANEL_CUSTOM_LIB_URL ?
          MIXPANEL_CUSTOM_LIB_URL : "file:" === f.location.protocol && "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\/\//) ? "https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js" : "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js"; g = f.getElementsByTagName("script")[0]; g.parentNode.insertBefore(e, g)
      }
    })(document, window.mixpanel || []);
    mixpanel.init(process.env.MIXPANEL_TRACKING_KEY, { batch_requests: true })
    // mixpanel.init(process.env.MIXPANEL_TRACKING_KEY);
    MIXPANEL_INITIALIZED = true;
  }
}

function __wrapMixpanel__(executor) {
  return new Promise((resolve, reject) => {
    Promise.resolve(ALLOW_MIXPANEL)
      .then(allowMixpanel => {
        if (allowMixpanel === true && isFunction(executor)) {
          executor(resolve, reject);
        }
      }).finally(resolve);
  });
}

function init() {
  const allowMixpanel = isBoolean(ALLOW_MIXPANEL)
    ? Promise.resolve(ALLOW_MIXPANEL)
    : getChargeData().then(data => {
      CUSTOMER_EMAIL = (getValueAtPath(data, 'email') || '')
        .trim()
        .toLowerCase()
        .replace(/^([^@]+)(?=@|$)/, (_, $1) => md5($1));

      CUSTOMER_FIRSTNAME = md5(getValueAtPath(data, 'firstname') || '');
      CUSTOMER_LASTNAME = md5(getValueAtPath(data, 'lastname') || '');
      MERCHANT_NAME = getValueAtPath(data, 'merchant_name');
      TX_REF = getValueAtPath(data, 'txref');

      return (ALLOW_MIXPANEL = !getValueAtPath(data, 'preferences[prefers_reduced_tracking]'));
    });

  allowMixpanel.then(allowMixpanel => {
    if (allowMixpanel === true) {
      __initMixpanel__();
      MIXPANEL_INITIALIZED ? initiatePayment() : void 0;
    }
  });
}

function initiatePayment() {
  return __wrapMixpanel__((resolve, reject) => {
    try {
      const state = STORE.getState();

      const amount = getValueAtPath(state, 'amount');
      const currency = getValueAtPath(state, 'currency.current');
      const method = getValueAtPath(state, 'method.current');

      mixpanel.track('Payment initiated on Flutterwave Checkout', {
        "$email": CUSTOMER_EMAIL,
        "$merchant_name": MERCHANT_NAME,
        "$amount": amount,
        "payment_method": method,
        "$currency": currency,
        "$txref": TX_REF,
        "$first_name": CUSTOMER_FIRSTNAME,
        "$last_name": CUSTOMER_LASTNAME
      }, {
        transport: 'xhr',
        send_immediately: true
      }, resolve);
    } catch (e) { reject(e) }
  });
}

function completedPayment() {
  return __wrapMixpanel__((resolve, reject) => {
    try {
      const state = STORE.getState();

      const amount = getValueAtPath(state, 'amount');
      const currency = getValueAtPath(state, 'currency.current');
      const method = getValueAtPath(state, 'method.current');

      mixpanel.track('Payment made on Flutterwave Checkout', {
        "$email": CUSTOMER_EMAIL,
        "$merchant_name": MERCHANT_NAME,
        "$amount": amount,
        "payment_method": method,
        "$currency": currency,
        "$txref": TX_REF,
        "$first_name": CUSTOMER_FIRSTNAME,
        "$last_name": CUSTOMER_LASTNAME
      }, {
        transport: 'xhr',
        send_immediately: true
      }, resolve);
    } catch (e) { reject(e) }
  });
}

function paymentFailed(error) {
  return __wrapMixpanel__((resolve, reject) => {
    try {
      const state = STORE.getState();

      const amount = getValueAtPath(state, 'amount');
      const currency = getValueAtPath(state, 'currency.current');
      const method = getValueAtPath(state, 'method.current');

      mixpanel.track('Payment failed on Flutterwave Checkout', {
        "$email": CUSTOMER_EMAIL,
        "$merchant_name": MERCHANT_NAME,
        "$amount": amount,
        "payment_method": method,
        "$currency": currency,
        "$txref": TX_REF,
        "$first_name": CUSTOMER_FIRSTNAME,
        "$last_name": CUSTOMER_LASTNAME,
        ...(error && { "$error_message": error }),
      }, {
        transport: 'xhr',
        send_immediately: true
      }, resolve);
    } catch (e) { reject(e) }
  });
}

function paymentTimeout() {
  return __wrapMixpanel__((resolve, reject) => {
    try {
      const state = STORE.getState();

      const amount = getValueAtPath(state, 'amount');
      const currency = getValueAtPath(state, 'currency.current');
      const method = getValueAtPath(state, 'method.current');

      mixpanel.track('Payment session timeout on Flutterwave Checkout', {
        "$email": CUSTOMER_EMAIL,
        "$merchant_name": MERCHANT_NAME,
        "$amount": amount,
        "payment_method": method,
        "$currency": currency,
        "$txref": TX_REF,
        "$first_name": CUSTOMER_FIRSTNAME,
        "$last_name": CUSTOMER_LASTNAME
      }, {
        transport: 'xhr',
        send_immediately: true
      }, resolve);
    } catch (e) { reject(e) }
  });
}

function pendingPayment() {
  return __wrapMixpanel__((resolve, reject) => {
    try {
      const state = STORE.getState();

      const amount = getValueAtPath(state, 'amount');
      const currency = getValueAtPath(state, 'currency.current');
      const method = getValueAtPath(state, 'method.current');

      mixpanel.track('Payment pending on Flutterwave Checkout', {
        "$email": CUSTOMER_EMAIL,
        "$merchant_name": MERCHANT_NAME,
        "$amount": amount,
        "payment_method": method,
        "$currency": currency,
        "$txref": TX_REF,
        "$first_name": CUSTOMER_FIRSTNAME,
        "$last_name": CUSTOMER_LASTNAME
      }, {
        transport: 'xhr',
        send_immediately: true
      }, resolve);
    } catch (e) { reject(e) }
  });
}

function mixpanelInitialized() {
  return MIXPANEL_INITIALIZED
}

export default withProperties(Object.create(null), {
  init,
  completedPayment,
  paymentFailed,
  paymentTimeout,
  pendingPayment,
  mixpanelInitialized
});
